import LoginForm from "pages/auth/login/components/login-form/LoginForm";
import React, { Component } from "react";

/**
 * Login component.
 */
export class LoginPage extends Component {
  public render() {
    return (
      <div>
        <LoginForm />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/login/Login.page.tsx